import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#000000'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#000000',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    description: {
        width: '80%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qtd: {
        width: '10%',
        borderRightColor: borderColor,
        textAlign: 'center',
        borderRightWidth: 1,
    },
    status: {
        width: '10%'
    },
  });

  const OrderServiceTasksTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.description}>Descrição</Text>
        <Text style={styles.qtd}>Qtd</Text>
        <Text style={styles.status}>Status</Text>
    </View>
  );
  
  export default OrderServiceTasksTableHeader